var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Cache {
  constructor(domainKey = "FX") {
    __publicField(this, "prefixKey");
    this.prefixKey = domainKey;
  }
  set(key, value) {
    localStorage.setItem(`${this.prefixKey}.${key}`, value);
  }
  get(key) {
    return localStorage.getItem(`${this.prefixKey}.${key}`);
  }
  remove(key) {
    localStorage.removeItem(`${this.prefixKey}.${key}`);
  }
}
const defaultCacheObj = new Cache();
export { Cache, defaultCacheObj };
